// import React, { useState, useEffect, useCallback } from 'react';
// import { Link } from 'react-router-dom';
// import { getProjects, deleteProject } from '../utils/api';
// import toast from 'react-hot-toast';

// const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

// export default function ProjectsPage() {
//   const [projects, setProjects] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [searchInput, setSearchInput] = useState('');
//   const [category, setCategory] = useState('all');
//   const [page, setPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [total, setTotal] = useState(0);
//   const [deleting, setDeleting] = useState(null);

//   const fetch = useCallback(() => {
//     setLoading(true);
//     getProjects({ page, limit: 10, search: search || undefined, category: category === 'all' ? undefined : category })
//       .then(r => { setProjects(r.data.data); setTotalPages(r.data.totalPages); setTotal(r.data.total); })
//       .catch(() => toast.error('Failed to load projects'))
//       .finally(() => setLoading(false));
//   }, [page, search, category]);

//   useEffect(() => { fetch(); }, [fetch]);
//   useEffect(() => { setPage(1); }, [search, category]);

//   const handleDelete = async (id, title) => {
//     if (!window.confirm(`Delete "${title}"? This cannot be undone.`)) return;
//     setDeleting(id);
//     try {
//       await deleteProject(id);
//       toast.success('Project deleted');
//       fetch();
//     } catch { toast.error('Failed to delete'); }
//     finally { setDeleting(null); }
//   };

//   const getThumb = (project) => {
//     const img = project.images?.find(i => i.isThumbnail) || project.images?.[0];
//     if (!img?.url) return null;
//     return img.url.startsWith('http') ? img.url : `${API_BASE}${img.url}`;
//   };

//   const CATS = ['all', '2BHK', '3BHK', '4BHK', 'Penthouse', 'Villa', 'Commercial', 'Office', 'Retail', 'Custom'];

//   return (
//     <div className="space-y-5">
//       {/* Header */}
//       <div className="flex items-center justify-between gap-4 flex-wrap">
//         <div>
//           <h1 className="font-display text-xl font-semibold text-surface-100">Projects</h1>
//           <p className="text-surface-500 text-sm mt-0.5">{total} total projects</p>
//         </div>
//         <Link to="/projects/new" className="btn-primary flex items-center gap-2">
//           <span>+</span> Add Project
//         </Link>
//       </div>

//       {/* Filters */}
//       <div className="card p-4 flex flex-col sm:flex-row gap-3">
//         <div className="flex overflow-x-auto gap-1.5">
//           {CATS.map(cat => (
//             <button key={cat} onClick={() => setCategory(cat)}
//               className={`flex-shrink-0 px-3 py-1.5 rounded text-xs font-medium transition-colors ${category === cat ? 'bg-brand-400 text-surface-900' : 'bg-surface-700 text-surface-400 hover:text-surface-200'}`}>
//               {cat}
//             </button>
//           ))}
//         </div>
//         <form onSubmit={e => { e.preventDefault(); setSearch(searchInput); }} className="flex gap-2 ml-auto flex-shrink-0">
//           <input value={searchInput} onChange={e => setSearchInput(e.target.value)} placeholder="Search projects…"
//             className="input w-48 py-1.5" />
//           <button type="submit" className="btn-secondary py-1.5 px-3">Search</button>
//           {search && <button type="button" onClick={() => { setSearch(''); setSearchInput(''); }} className="btn-secondary py-1.5 px-3">✕</button>}
//         </form>
//       </div>

//       {/* Table */}
//       <div className="card overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead>
//               <tr className="border-b border-surface-700 text-left">
//                 <th className="px-4 py-3 text-surface-500 text-xs uppercase tracking-wide font-medium">Project</th>
//                 <th className="px-4 py-3 text-surface-500 text-xs uppercase tracking-wide font-medium hidden sm:table-cell">Category</th>
//                 <th className="px-4 py-3 text-surface-500 text-xs uppercase tracking-wide font-medium hidden md:table-cell">Location</th>
//                 <th className="px-4 py-3 text-surface-500 text-xs uppercase tracking-wide font-medium hidden lg:table-cell">Status</th>
//                 <th className="px-4 py-3 text-surface-500 text-xs uppercase tracking-wide font-medium">Published</th>
//                 <th className="px-4 py-3 text-surface-500 text-xs uppercase tracking-wide font-medium text-right">Actions</th>
//               </tr>
//             </thead>
//             <tbody className="divide-y divide-surface-700">
//               {loading ? (
//                 [...Array(5)].map((_, i) => (
//                   <tr key={i}>
//                     {[...Array(6)].map((_, j) => (
//                       <td key={j} className="px-4 py-3"><div className="h-4 bg-surface-700 rounded animate-pulse" /></td>
//                     ))}
//                   </tr>
//                 ))
//               ) : projects.length === 0 ? (
//                 <tr><td colSpan={6} className="px-4 py-12 text-center text-surface-600 text-sm">No projects found</td></tr>
//               ) : projects.map(project => (
//                 <tr key={project._id} className="hover:bg-surface-700/30 transition-colors">
//                   <td className="px-4 py-3">
//                     <div className="flex items-center gap-3">
//                       <div className="w-10 h-10 rounded bg-surface-700 flex-shrink-0 overflow-hidden">
//                         {getThumb(project)
//                           ? <img src={getThumb(project)} alt="" className="w-full h-full object-cover" onError={e => { e.target.style.display = 'none'; }} />
//                           : <div className="w-full h-full flex items-center justify-center text-surface-600 text-xs">◻</div>
//                         }
//                       </div>
//                       <div className="min-w-0">
//                         <p className="text-surface-200 text-sm font-medium truncate max-w-[180px]">{project.title}</p>
//                         <p className="text-surface-500 text-xs">{project.images?.length || 0} images · {project.videos?.length || 0} videos</p>
//                       </div>
//                     </div>
//                   </td>
//                   <td className="px-4 py-3 hidden sm:table-cell">
//                     <span className="bg-brand-400/15 text-brand-400 text-xs px-2 py-0.5 rounded">{project.category}</span>
//                   </td>
//                   <td className="px-4 py-3 text-surface-400 text-sm hidden md:table-cell">{project.location}</td>
//                   <td className="px-4 py-3 hidden lg:table-cell">
//                     <span className={`text-xs px-2 py-0.5 rounded ${
//                       project.status === 'Completed' ? 'bg-green-500/15 text-green-400' :
//                       project.status === 'Ongoing' ? 'bg-blue-500/15 text-blue-400' :
//                       'bg-amber-500/15 text-amber-400'}`}>{project.status}</span>
//                   </td>
//                   <td className="px-4 py-3">
//                     <span className={`text-xs px-2 py-0.5 rounded-full ${project.isPublished ? 'bg-green-500/15 text-green-400' : 'bg-surface-700 text-surface-500'}`}>
//                       {project.isPublished ? '● Live' : '○ Draft'}
//                     </span>
//                   </td>
//                   <td className="px-4 py-3 text-right">
//                     <div className="flex items-center justify-end gap-2">
//                       <Link to={`/projects/edit/${project._id}`} className="text-surface-400 hover:text-brand-400 transition-colors text-xs px-2 py-1 hover:bg-surface-700 rounded">Edit</Link>
//                       <button onClick={() => handleDelete(project._id, project.title)} disabled={deleting === project._id}
//                         className="text-surface-500 hover:text-red-400 transition-colors text-xs px-2 py-1 hover:bg-surface-700 rounded disabled:opacity-50">
//                         {deleting === project._id ? '…' : 'Delete'}
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {totalPages > 1 && (
//           <div className="flex items-center justify-between px-4 py-3 border-t border-surface-700">
//             <p className="text-surface-500 text-xs">Page {page} of {totalPages}</p>
//             <div className="flex gap-1">
//               <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1}
//                 className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">← Prev</button>
//               <button onClick={() => setPage(p => Math.min(totalPages, p + 1))} disabled={page === totalPages}
//                 className="btn-secondary py-1 px-3 text-xs disabled:opacity-40">Next →</button>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// }







// import React, { useState, useEffect, useCallback } from 'react';
// import { Link } from 'react-router-dom';
// import { Plus, Search, Edit, Trash2, Image, MapPin, Eye, EyeOff, Star } from 'lucide-react';
// import { getAdminProjects, deleteProject } from '../utils/api';
// import toast from 'react-hot-toast';
// import ConfirmModal from '../components/ConfirmModal';

// export default function ProjectsPage() {
//   const [projects, setProjects] = useState([]);
//   const [meta, setMeta] = useState({ current_page: 1, last_page: 1, total: 0 });
//   const [loading, setLoading] = useState(true);
//   const [search, setSearch] = useState('');
//   const [page, setPage] = useState(1);
//   const [deleteId, setDeleteId] = useState(null);

//   const fetchProjects = useCallback(async () => {
//     setLoading(true);
//     try {
//       const res = await getAdminProjects({ search, page, per_page: 15 });
//       setProjects(res.data.data || []);
//       setMeta(res.data.meta || {});
//     } catch (err) {
//       toast.error('Failed to load projects');
//     } finally {
//       setLoading(false);
//     }
//   }, [search, page]);

//   useEffect(() => {
//     const t = setTimeout(fetchProjects, search ? 400 : 0);
//     return () => clearTimeout(t);
//   }, [fetchProjects]);

//   const handleDelete = async () => {
//     try {
//       await deleteProject(deleteId);
//       toast.success('Project deleted');
//       setDeleteId(null);
//       fetchProjects();
//     } catch {
//       toast.error('Failed to delete');
//     }
//   };

//   return (
//     <div>
//       <div className="flex items-center justify-between mb-6">
//         <div>
//           <h1 className="text-xl font-semibold text-white">Projects</h1>
//           <p className="text-white/40 text-sm mt-0.5">{meta.total || 0} total projects</p>
//         </div>
//         <Link to="/projects/new" className="btn-primary">
//           <Plus size={15} /> New Project
//         </Link>
//       </div>

//       {/* Search */}
//       <div className="card p-4 mb-4">
//         <div className="relative max-w-sm">
//           <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
//           <input
//             value={search}
//             onChange={e => { setSearch(e.target.value); setPage(1); }}
//             placeholder="Search projects..."
//             className="input pl-9 py-2"
//           />
//         </div>
//       </div>

//       {/* Table */}
//       <div className="card overflow-hidden">
//         <div className="overflow-x-auto">
//           <table className="w-full">
//             <thead className="border-b border-white/8">
//               <tr>
//                 <th className="table-header text-left">Project</th>
//                 <th className="table-header text-left hidden md:table-cell">Type</th>
//                 <th className="table-header text-left hidden lg:table-cell">Location</th>
//                 <th className="table-header text-left hidden lg:table-cell">Status</th>
//                 <th className="table-header text-center">Featured</th>
//                 <th className="table-header text-right">Actions</th>
//               </tr>
//             </thead>
//             <tbody>
//               {loading ? (
//                 [...Array(8)].map((_, i) => (
//                   <tr key={i}>
//                     {[...Array(6)].map((_, j) => (
//                       <td key={j} className="py-3 px-4">
//                         <div className="skeleton h-4 rounded w-full" />
//                       </td>
//                     ))}
//                   </tr>
//                 ))
//               ) : projects.length === 0 ? (
//                 <tr>
//                   <td colSpan={6} className="py-16 text-center text-white/30 text-sm">
//                     No projects found. <Link to="/projects/new" className="text-primary-400 hover:underline">Create one</Link>
//                   </td>
//                 </tr>
//               ) : (
//                 projects.map(project => (
//                   <tr key={project.id} className="hover:bg-white/2 transition-colors">
//                     <td className="table-cell">
//                       <div className="flex items-center gap-3">
//                         <div className="w-10 h-10 rounded-lg bg-surface-700 overflow-hidden shrink-0">
//                           {project.thumbnail_url ? (
//                             <img src={project.thumbnail_url} alt={project.title} className="w-full h-full object-cover" />
//                           ) : (
//                             <div className="w-full h-full flex items-center justify-center text-white/20">
//                               <Image size={14} />
//                             </div>
//                           )}
//                         </div>
//                         <div className="min-w-0">
//                           <div className="font-medium text-white truncate max-w-[200px]">{project.title}</div>
//                           <div className="text-xs text-white/30 truncate">{project.category?.name || '—'}</div>
//                         </div>
//                       </div>
//                     </td>
//                     <td className="table-cell hidden md:table-cell">
//                       <span className="badge bg-primary-500/10 text-primary-400">{project.project_type}</span>
//                     </td>
//                     <td className="table-cell hidden lg:table-cell">
//                       <span className="flex items-center gap-1 text-white/50">
//                         <MapPin size={11} /> {project.location}
//                       </span>
//                     </td>
//                     <td className="table-cell hidden lg:table-cell">
//                       <span className={`badge capitalize ${
//                         project.status === 'completed' ? 'bg-green-500/10 text-green-400' :
//                         project.status === 'ongoing'   ? 'bg-blue-500/10 text-blue-400' :
//                                                          'bg-yellow-500/10 text-yellow-400'
//                       }`}>{project.status}</span>
//                     </td>
//                     <td className="table-cell text-center">
//                       {project.is_featured
//                         ? <Star size={14} className="mx-auto text-primary-400 fill-primary-400" />
//                         : <Star size={14} className="mx-auto text-white/15" />
//                       }
//                     </td>
//                     <td className="table-cell text-right">
//                       <div className="flex items-center justify-end gap-1">
//                         <Link to={`/projects/${project.id}/media`} className="btn-ghost p-2" title="Manage Media">
//                           <Image size={14} />
//                         </Link>
//                         <Link to={`/projects/${project.id}/edit`} className="btn-ghost p-2" title="Edit">
//                           <Edit size={14} />
//                         </Link>
//                         <button onClick={() => setDeleteId(project.id)} className="btn-ghost p-2 text-red-400/60 hover:text-red-400 hover:bg-red-500/10" title="Delete">
//                           <Trash2 size={14} />
//                         </button>
//                       </div>
//                     </td>
//                   </tr>
//                 ))
//               )}
//             </tbody>
//           </table>
//         </div>

//         {/* Pagination */}
//         {meta.last_page > 1 && (
//           <div className="flex items-center justify-between px-4 py-3 border-t border-white/8">
//             <span className="text-white/30 text-xs">Page {meta.current_page} of {meta.last_page}</span>
//             <div className="flex gap-1">
//               <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="btn-ghost py-1 px-2 text-xs disabled:opacity-40">Previous</button>
//               <button onClick={() => setPage(p => Math.min(meta.last_page, p + 1))} disabled={page === meta.last_page} className="btn-ghost py-1 px-2 text-xs disabled:opacity-40">Next</button>
//             </div>
//           </div>
//         )}
//       </div>

//       <ConfirmModal
//         open={!!deleteId}
//         title="Delete Project"
//         message="Are you sure? This will also delete all associated media files. This action cannot be undone."
//         onConfirm={handleDelete}
//         onCancel={() => setDeleteId(null)}
//         danger
//       />
//     </div>
//   );
// }


import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { Plus, Search, Edit, Trash2, Image, MapPin, Star, LayoutGrid, List, Filter, ChevronLeft, ChevronRight, Sparkles } from 'lucide-react';
import { getAdminProjects, deleteProject } from '../utils/api';
import toast from 'react-hot-toast';
import ConfirmModal from '../components/ConfirmModal';

const STATUS_CONFIG = {
  completed: { label: 'Completed', color: 'bg-emerald-500/15 text-emerald-400 border-emerald-500/20' },
  ongoing:   { label: 'Ongoing',   color: 'bg-sky-500/15 text-sky-400 border-sky-500/20' },
  upcoming:  { label: 'Upcoming',  color: 'bg-amber-500/15 text-amber-400 border-amber-500/20' },
};

export default function ProjectsPage() {
  const [projects, setProjects] = useState([]);
  const [meta, setMeta] = useState({ current_page: 1, last_page: 1, total: 0 });
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [viewMode, setViewMode] = useState('table'); // 'table' | 'grid'

  const fetchProjects = useCallback(async () => {
    setLoading(true);
    try {
      const res = await getAdminProjects({ search, page, per_page: 15 });
      setProjects(res.data.data || []);
      setMeta(res.data.meta || {});
    } catch {
      toast.error('Failed to load projects');
    } finally {
      setLoading(false);
    }
  }, [search, page]);

  useEffect(() => {
    const t = setTimeout(fetchProjects, search ? 400 : 0);
    return () => clearTimeout(t);
  }, [fetchProjects]);

  const handleDelete = async () => {
    try {
      await deleteProject(deleteId);
      toast.success('Project deleted');
      setDeleteId(null);
      fetchProjects();
    } catch {
      toast.error('Failed to delete');
    }
  };

  const SkeletonRow = () => (
    <tr>
      <td className="px-5 py-4">
        <div className="flex items-center gap-3">
          <div className="w-12 h-12 rounded-xl bg-white/5 animate-pulse shrink-0" />
          <div className="space-y-2">
            <div className="h-3.5 w-36 bg-white/5 rounded-full animate-pulse" />
            <div className="h-2.5 w-20 bg-white/5 rounded-full animate-pulse" />
          </div>
        </div>
      </td>
      {[...Array(4)].map((_, i) => (
        <td key={i} className="px-5 py-4 hidden md:table-cell">
          <div className="h-3 w-20 bg-white/5 rounded-full animate-pulse" />
        </td>
      ))}
      <td className="px-5 py-4">
        <div className="h-3 w-16 bg-white/5 rounded-full animate-pulse ml-auto" />
      </td>
    </tr>
  );

  const SkeletonCard = () => (
    <div className="rounded-2xl overflow-hidden border border-white/8 bg-white/3 animate-pulse">
      <div className="aspect-[4/3] bg-white/5" />
      <div className="p-4 space-y-2">
        <div className="h-3.5 w-3/4 bg-white/5 rounded-full" />
        <div className="h-2.5 w-1/2 bg-white/5 rounded-full" />
      </div>
    </div>
  );

  return (
    <div>
      {/* Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-white tracking-tight">Projects</h1>
          <p className="text-white/40 text-sm mt-1">
            {loading ? '—' : meta.total || 0} projects in your portfolio
          </p>
        </div>
        <Link
          to="/projects/new"
          className="flex items-center gap-2 px-4 py-2.5 bg-gradient-to-r from-violet-500 to-indigo-500 hover:from-violet-400 hover:to-indigo-400 text-white text-sm font-semibold rounded-xl transition-all duration-200 shadow-lg shadow-violet-500/20 hover:shadow-violet-500/30 hover:-translate-y-0.5"
        >
          <Plus size={15} strokeWidth={2.5} /> New Project
        </Link>
      </div>

      {/* Toolbar */}
      <div className="flex items-center gap-3 mb-5">
        <div className="relative flex-1 max-w-xs">
          <Search size={14} className="absolute left-3.5 top-1/2 -translate-y-1/2 text-white/30" />
          <input
            value={search}
            onChange={e => { setSearch(e.target.value); setPage(1); }}
            placeholder="Search projects..."
            className="w-full bg-white/5 border border-white/10 text-white text-sm placeholder:text-white/25 rounded-xl pl-9 pr-4 py-2.5 focus:outline-none focus:border-violet-500/50 focus:bg-white/8 transition-all"
          />
        </div>
        <div className="ml-auto flex items-center gap-1 p-1 bg-white/5 border border-white/8 rounded-xl">
          <button
            onClick={() => setViewMode('table')}
            className={`p-2 rounded-lg transition-all ${viewMode === 'table' ? 'bg-white/10 text-white' : 'text-white/30 hover:text-white/60'}`}
            title="Table view"
          >
            <List size={15} />
          </button>
          <button
            onClick={() => setViewMode('grid')}
            className={`p-2 rounded-lg transition-all ${viewMode === 'grid' ? 'bg-white/10 text-white' : 'text-white/30 hover:text-white/60'}`}
            title="Grid view"
          >
            <LayoutGrid size={15} />
          </button>
        </div>
      </div>

      {/* Table View */}
      {viewMode === 'table' && (
        <div className="rounded-2xl border border-white/8 bg-white/3 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-white/8">
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-white/35 uppercase tracking-wider">Project</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-white/35 uppercase tracking-wider hidden md:table-cell">Type</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-white/35 uppercase tracking-wider hidden lg:table-cell">Location</th>
                  <th className="text-left px-5 py-3.5 text-xs font-semibold text-white/35 uppercase tracking-wider hidden lg:table-cell">Status</th>
                  <th className="text-center px-5 py-3.5 text-xs font-semibold text-white/35 uppercase tracking-wider">Featured</th>
                  <th className="text-right px-5 py-3.5 text-xs font-semibold text-white/35 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-white/5">
                {loading ? (
                  [...Array(8)].map((_, i) => <SkeletonRow key={i} />)
                ) : projects.length === 0 ? (
                  <tr>
                    <td colSpan={6} className="py-20 text-center">
                      <div className="flex flex-col items-center gap-3">
                        <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center">
                          <Sparkles size={24} className="text-white/15" />
                        </div>
                        <p className="text-white/30 text-sm">No projects found</p>
                        <Link to="/projects/new" className="text-violet-400 hover:text-violet-300 text-sm font-medium transition-colors">
                          + Create your first project
                        </Link>
                      </div>
                    </td>
                  </tr>
                ) : (
                  projects.map(project => {
                    const status = STATUS_CONFIG[project.status] || STATUS_CONFIG.upcoming;
                    return (
                      <tr key={project.id} className="group hover:bg-white/3 transition-colors">
                        <td className="px-5 py-3.5">
                          <div className="flex items-center gap-3">
                            <div className="w-12 h-12 rounded-xl bg-white/5 overflow-hidden shrink-0 border border-white/8">
                              {project.thumbnail_url ? (
                                <img src={project.thumbnail_url} alt={project.title} className="w-full h-full object-cover" />
                              ) : (
                                <div className="w-full h-full flex items-center justify-center text-white/15">
                                  <Image size={16} />
                                </div>
                              )}
                            </div>
                            <div className="min-w-0">
                              <div className="font-semibold text-white text-sm truncate max-w-[180px]">{project.title}</div>
                              <div className="text-xs text-white/35 mt-0.5 truncate">{project.category?.name || 'Uncategorized'}</div>
                            </div>
                          </div>
                        </td>
                        <td className="px-5 py-3.5 hidden md:table-cell">
                          <span className="text-xs font-medium px-2.5 py-1 rounded-lg bg-violet-500/10 text-violet-400 border border-violet-500/20">
                            {project.project_type}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 hidden lg:table-cell">
                          <span className="flex items-center gap-1.5 text-white/45 text-sm">
                            <MapPin size={12} className="text-white/25 shrink-0" />
                            {project.location || '—'}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 hidden lg:table-cell">
                          <span className={`text-xs font-medium px-2.5 py-1 rounded-lg border capitalize ${status.color}`}>
                            {status.label}
                          </span>
                        </td>
                        <td className="px-5 py-3.5 text-center">
                          {project.is_featured
                            ? <Star size={14} className="mx-auto text-amber-400 fill-amber-400" />
                            : <Star size={14} className="mx-auto text-white/12" />
                          }
                        </td>
                        <td className="px-5 py-3.5">
                          <div className="flex items-center justify-end gap-1">
                            <Link
                              to={`/projects/${project.id}/media`}
                              className="p-2 rounded-lg text-white/35 hover:text-white hover:bg-white/8 transition-all"
                              title="Manage Media"
                            >
                              <Image size={14} />
                            </Link>
                            <Link
                              to={`/projects/${project.id}/edit`}
                              className="p-2 rounded-lg text-white/35 hover:text-white hover:bg-white/8 transition-all"
                              title="Edit"
                            >
                              <Edit size={14} />
                            </Link>
                            <button
                              onClick={() => setDeleteId(project.id)}
                              className="p-2 rounded-lg text-white/25 hover:text-red-400 hover:bg-red-500/10 transition-all"
                              title="Delete"
                            >
                              <Trash2 size={14} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Pagination */}
          {meta.last_page > 1 && (
            <div className="flex items-center justify-between px-5 py-3.5 border-t border-white/8">
              <span className="text-white/30 text-xs">
                Page {meta.current_page} of {meta.last_page} · {meta.total} total
              </span>
              <div className="flex items-center gap-1">
                <button
                  onClick={() => setPage(p => Math.max(1, p - 1))}
                  disabled={page === 1}
                  className="flex items-center gap-1 px-3 py-1.5 text-xs rounded-lg text-white/50 hover:text-white hover:bg-white/8 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                >
                  <ChevronLeft size={13} /> Prev
                </button>
                <button
                  onClick={() => setPage(p => Math.min(meta.last_page, p + 1))}
                  disabled={page === meta.last_page}
                  className="flex items-center gap-1 px-3 py-1.5 text-xs rounded-lg text-white/50 hover:text-white hover:bg-white/8 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
                >
                  Next <ChevronRight size={13} />
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      {/* Grid View */}
      {viewMode === 'grid' && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          {loading
            ? [...Array(8)].map((_, i) => <SkeletonCard key={i} />)
            : projects.length === 0
            ? (
              <div className="col-span-full py-20 flex flex-col items-center gap-3">
                <div className="w-16 h-16 rounded-2xl bg-white/5 flex items-center justify-center">
                  <Sparkles size={24} className="text-white/15" />
                </div>
                <p className="text-white/30 text-sm">No projects found</p>
                <Link to="/projects/new" className="text-violet-400 hover:text-violet-300 text-sm font-medium">+ Create one</Link>
              </div>
            )
            : projects.map(project => {
              const status = STATUS_CONFIG[project.status] || STATUS_CONFIG.upcoming;
              return (
                <div key={project.id} className="group rounded-2xl border border-white/8 bg-white/3 hover:bg-white/5 hover:border-white/15 transition-all duration-200 overflow-hidden">
                  <div className="relative aspect-[4/3] bg-white/5">
                    {project.thumbnail_url ? (
                      <img src={project.thumbnail_url} alt={project.title} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-white/10">
                        <Image size={32} />
                      </div>
                    )}
                    {project.is_featured && (
                      <div className="absolute top-2 left-2 flex items-center gap-1 px-2 py-0.5 rounded-full bg-amber-500/20 border border-amber-500/30 text-amber-400 text-[10px] font-medium">
                        <Star size={9} className="fill-amber-400" /> Featured
                      </div>
                    )}
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
                    <div className="absolute bottom-2 right-2 flex gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                      <Link to={`/projects/${project.id}/media`} className="p-1.5 bg-white/10 backdrop-blur rounded-lg text-white hover:bg-white/20 transition-colors">
                        <Image size={12} />
                      </Link>
                      <Link to={`/projects/${project.id}/edit`} className="p-1.5 bg-white/10 backdrop-blur rounded-lg text-white hover:bg-white/20 transition-colors">
                        <Edit size={12} />
                      </Link>
                      <button onClick={() => setDeleteId(project.id)} className="p-1.5 bg-red-500/40 backdrop-blur rounded-lg text-white hover:bg-red-500/60 transition-colors">
                        <Trash2 size={12} />
                      </button>
                    </div>
                  </div>
                  <div className="p-3.5">
                    <div className="font-semibold text-white text-sm truncate">{project.title}</div>
                    <div className="flex items-center justify-between mt-2">
                      <span className="flex items-center gap-1 text-white/40 text-xs">
                        <MapPin size={10} /> {project.location || '—'}
                      </span>
                      <span className={`text-[10px] font-medium px-2 py-0.5 rounded-full border capitalize ${status.color}`}>
                        {status.label}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })
          }
        </div>
      )}

      <ConfirmModal
        open={!!deleteId}
        title="Delete Project"
        message="Are you sure? This will also delete all associated media files. This action cannot be undone."
        onConfirm={handleDelete}
        onCancel={() => setDeleteId(null)}
        danger
      />
    </div>
  );
}